import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createQuote } from "../apis/createQuote";
import type { ApiResponse } from "../../../types/apiResponse";

export const useCreateQuote = () => {
    const queryClient = useQueryClient();

    return useMutation<ApiResponse, Error, any>({
        mutationFn: createQuote,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
        },
    });
};
